// Module
var code = `<multiselect items="\$ctrl.definitions"
             ng-model="\$ctrl.selectedDefinitions"
             ng-change="\$ctrl.onChangeUpdate()"
             label-property="'name'"
             value-property="'id'">
</multiselect>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/custom-field/common/custom-field-definition-multiselect.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;